<script>
  export let loader;
  log2('page', '3d-loaded');
  loggin('page', '3d-loaded');
</script>

<style>
  .loader {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: #000000;
    display: flex;
    z-index: 5;
    justify-content: center;
  }

  .loader-animation {
    background-size: contain !important;
    background-repeat: no-repeat !important;
    height: 20px;
    width: 70px;
    align-self: center;
  }
</style>

<div class="loader">
  <div class="loader-animation" style="background: url({loader})"/>
</div>
